import { ChangeEvent, FormEvent, useState } from 'react';
import { api } from '../api';

const contactInfo = {
    name: "Lukas Otterström",
    phone: "+46(0) 705 90 88 13",
    email: "lukas@forget-it.se",
    location: "Stockholm, Sweden",
    linkedin: "https://www.linkedin.com/in/lukas-otterstr%C3%B6m-793877158/"
};

export default function Contact() {
    const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState<{ type: 'success' | 'error'; message: string } | null>(null);

    const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            const response = await api.post('/contact', formData);
            if (response.status === 200) {
                setSubmitStatus({ type: 'success', message: "Message sent! We'll get back to you soon." });
                setFormData({ name: '', email: '', subject: '', message: '' });
            }
        } catch (error) {
            setSubmitStatus({ type: 'error', message: 'Failed to send message. Please try again or contact us directly.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section className="section">
            <span className="section-label">Contact</span>
            <h2>Ready to forget about IT?</h2>
            <p className="section-desc">
                Tell us what you need and we'll take it from here. Your tech is our problem — that's the whole point.
            </p>

            <div className="contact-grid">
                <div className="contact-info-card" data-aos="fade-up">
                    <h3>Contact Information</h3>
                    <ul className="contact-list">
                        <li>
                            <span className="contact-icon">&#9786;</span>
                            <strong>{contactInfo.name}</strong>
                        </li>
                        <li>
                            <span className="contact-icon">&#9742;</span>
                            <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
                        </li>
                        <li>
                            <span className="contact-icon">&#9993;</span>
                            <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                        </li>
                        <li>
                            <span className="contact-icon">&#9872;</span>
                            {contactInfo.location}
                        </li>
                        <li>
                            <span className="contact-icon">&#128100;</span>
                            <a href={contactInfo.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
                        </li>
                    </ul>
                </div>

                <div className="contact-form-card" data-aos="fade-up" data-aos-delay="100">
                    <h3>Send a Message</h3>

                    {submitStatus && (
                        <div className={`form-alert ${submitStatus.type}`}>
                            {submitStatus.message}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <label>
                            Name
                            <input type="text" name="name" value={formData.name} onChange={handleInputChange} required placeholder="Your full name" />
                        </label>
                        <label>
                            Email
                            <input type="email" name="email" value={formData.email} onChange={handleInputChange} required placeholder="your.email@example.com" />
                        </label>
                        <label>
                            Subject
                            <input type="text" name="subject" value={formData.subject} onChange={handleInputChange} required placeholder="What can we help you with?" />
                        </label>
                        <label>
                            Message
                            <textarea name="message" rows={4} value={formData.message} onChange={handleInputChange} required placeholder="Tell us about your project..." />
                        </label>
                        <button type="submit" className="btn-submit" disabled={isSubmitting}>
                            {isSubmitting ? 'Sending...' : 'Send Message'}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
}
